import api from "./api";

class MaterialService {
    getRawMaterial(id) {
        return api.get(`/api/materials/raw-materials/${id}/`);
    }

    getAssembly(id) {
        return api.get(`/api/materials/assemblies/${id}/`);
    }

    searchRawMaterials(params = {}) {
        return api.get("/api/materials/raw-materials/", { params });
    }

    searchAssemblies(params = {}) {
        return api.get("/api/materials/assemblies/", { params });
    }

    adjustAssemblyStock(id, data) {
        return api.post(`/api/materials/assemblies/${id}/adjust-stock/`, data);
    }
}

export default new MaterialService();
